import { render, staticRenderFns } from "./gradePanel.vue?vue&type=template&id=8e8df7a6&scoped=true"
import script from "./gradePanel.vue?vue&type=script&lang=js"
export * from "./gradePanel.vue?vue&type=script&lang=js"
import style0 from "./gradePanel.vue?vue&type=style&index=0&id=8e8df7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8df7a6",
  null
  
)

export default component.exports